import { createClient } from '@supabase/supabase-js';

const REQUIRED_PROJECT_REF = 'darnmtgunuxoklpyfiea';
const FALLBACK_SUPABASE_URL = `https://${REQUIRED_PROJECT_REF}.supabase.co`;
const FALLBACK_SUPABASE_ANON_KEY = 'sb_publishable_OwFSJhDMphERJdP0Abhw5g_oMx77BHB';

const envSupabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const envSupabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';
const expectedHost = `${REQUIRED_PROJECT_REF}.supabase.co`;
const envHost = (() => {
  try {
    return envSupabaseUrl ? new URL(envSupabaseUrl).host : '';
  } catch {
    return '';
  }
})();

const isExpectedProject = envHost === expectedHost;

if (envSupabaseUrl && !isExpectedProject) {
  console.warn(
    `[supabase] Projeto inesperado em VITE_SUPABASE_URL (${envSupabaseUrl}). Usando fallback ${FALLBACK_SUPABASE_URL}.`,
  );
}

const supabaseUrl = isExpectedProject ? envSupabaseUrl : FALLBACK_SUPABASE_URL;
const supabaseAnonKey = isExpectedProject && envSupabaseAnonKey ? envSupabaseAnonKey : FALLBACK_SUPABASE_ANON_KEY;

function isNativePlatform() {
  if (typeof window === 'undefined') return false;
  if (typeof window.Capacitor?.isNativePlatform === 'function') {
    return window.Capacitor.isNativePlatform();
  }
  return false;
}

function getNativePlatform() {
  if (!isNativePlatform()) return 'web';
  return String(window.Capacitor?.getPlatform?.() || '').toLowerCase() || 'native';
}

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);
const authFlowType = (() => {
  const nativePlatform = getNativePlatform();
  if (nativePlatform !== 'web') return 'implicit';
  return 'pkce';
})();

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        // Native deep links work more reliably with the implicit flow, while web keeps PKCE.
        flowType: authFlowType,
        // We complete OAuth callbacks manually so web and native follow the same path.
        detectSessionInUrl: false,
      },
    })
  : null;

export function getSupabaseUrl() {
  return supabaseUrl;
}

export function getSupabaseAnonKey() {
  return supabaseAnonKey;
}

export function getSupabaseClient() {
  if (!supabase) {
    throw new Error(
      'Supabase nao configurado. Defina VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY no .env.',
    );
  }

  return supabase;
}
